// extracted by mini-css-extract-plugin
module.exports = {"footer":"HistoryItem_footer__1IScr"};